import { useModelStatusesStore, type ResolvedStatus } from '../../stores/useModelStatusesStore';
import styles from './ModelStatusBadge.module.css';

interface ModelStatusBadgeProps {
  modelId: string;
  modelType: 'chat' | 'image' | 'video';
  /** Show only in selector context (filters by showInSelector) */
  context?: 'selector' | 'composer';
  /** Compact mode for tighter layouts */
  compact?: boolean;
}

/**
 * ModelStatusBadge — solid vibrant pill badge (EXCLUSIVE / NEW style)
 * Renders next to model name in selectors/composers
 * Returns null if no active status for this model
 */
export const ModelStatusBadge = ({ modelId, modelType, context = 'selector', compact = false }: ModelStatusBadgeProps) => {
  const getStatus = useModelStatusesStore(state => state.getStatus);
  const status: ResolvedStatus | null = getStatus(modelId, modelType);

  if (!status) return null;

  // Respect visibility settings
  if (context === 'selector' && !status.showInSelector) return null;
  if (context === 'composer' && !status.showInComposer) return null;

  return (
    <span
      className={`${styles.statusBadge} ${compact ? styles.compact : ''}`}
      style={{ 
        backgroundColor: status.bgColor, // Solid color
        color: '#000000', // Black text
        border: 'none', // No border
        boxShadow: 'none' // No glow
      }}
    >
      <span className={styles.statusContent}>{status.text}</span>
    </span>
  );
};

export default ModelStatusBadge;
